import { render, staticRenderFns } from "./BrandKit.vue?vue&type=template&id=c7b7366a"
import script from "./BrandKit.vue?vue&type=script&lang=js"
export * from "./BrandKit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports